export default {"src":"/_next/static/media/elment3.56a468b2.svg","height":62,"width":91,"blurWidth":0,"blurHeight":0};